import { cloneDeep } from 'lodash';

export default {
  plugins(state) {
    return cloneDeep(state.plugins).sort((a, b) => a.plugin - b.plugin);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/plugin/getters.js